{
  "alert": "Výstraha",
  "dismiss": "Odstranit"
}